import type { AvailableFilterOptionDto } from './available-filter-option-dto.type';
import type { SearchFilterValueDto } from './search-filter-value-dto.type';

export interface SearchFilterRequest {
  entityType: string | null;
  fieldName: string;
  dataType: string;
  uiType: string;
  order: number | null;
  values: string[];
}

export const searchFilterRequestFactory = (
  filter: AvailableFilterOptionDto,
  values?: SearchFilterValueDto[],
): SearchFilterRequest => ({
  entityType: filter.entityType,
  fieldName: filter.fieldName,
  dataType: filter.dataType,
  uiType: filter.uiType,
  order: filter.order,
  values: values?.map((value) => value.id) ?? [],
});
